import React from 'react';

import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import ComplexSwitch from './ComplexSwitch';

interface IComplexSwitchProps {
  name: string;
  label?: string;
  required?: boolean;
  options: ISwitchOption[];
  dataTestId?: string;
  className?: string;
}

const ComplexSwitchFormik = ({
  label,
  name,
  required,
  options,
  dataTestId,
  className
}: IComplexSwitchProps) => {
  const [field, meta, helpers] = useField(name);
  const invalid = meta.touched && meta.error ? true : false;
  const { setValue, setTouched } = helpers;

  const handleClick = (value: string) => {
    setValue(value);
    setTouched(true, false);
  };

  return (
    <>
      <ComplexSwitch
        label={label}
        value={field.value}
        required={required}
        options={options}
        dataTestId={dataTestId}
        className={className}
        handleClick={handleClick}
      />
      {invalid && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default ComplexSwitchFormik;
